import { render, staticRenderFns } from "./SourceData.vue?vue&type=template&id=0bfb2cbc&scoped=true&"
import script from "./SourceData.ts?vue&type=script&lang=ts&"
export * from "./SourceData.ts?vue&type=script&lang=ts&"
import style0 from "./SourceData.scss?vue&type=style&index=0&id=0bfb2cbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfb2cbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VContainer,VDialog,VProgressCircular,VRow})
